import { trackApparelDiscoveryShowroomV2View } from "@faire/web-api/events/apparelDiscovery/view/showroomV2";
import { IBadge } from "@faire/web-api/indigofair/badges/IBadge";

export const handleShowroomProductBadgeViewed = (
  productToken: string,
  requestId: string = "",
  badgeViewed?: IBadge
) => {
  if (badgeViewed?.type === IBadge.BadgeType.SHOWROOM) {
    trackApparelDiscoveryShowroomV2View(
      "product-tile",
      productToken,
      requestId
    );
  }
};
